import { ICommentProps } from '@/components/Comment'

export const COMMENTS: ICommentProps[] = [
  {
    date: new Date(),
    name: 'Kauê Loviz',
    photoUrl: '/comments-profiles/kaue.png',
    text: 'Recomendo muito a Sancta Fatia! O processo de encomenda foi descomplicado e eficiente, e o atendimento foi excelente. Pedi um bolo de aniversário e todos ficaram impressionados com o sabor e a qualidade. Com certeza voltarei a encomendar.',
  },
  {
    date: new Date(),
    name: 'David Almeida',
    photoUrl: '/comments-profiles/david.png',
    text: 'Encomendar na Sancta Fatia foi super simples e prático. Fiz o pedido pelo site e a entrega foi pontual. O sabor do bolo era espetacular. O atendimento também foi muito cordial e atencioso.',
  },
  {
    date: new Date(),
    name: 'Juliana Gonzales',
    photoUrl: '/comments-profiles/juliana.png',
    text: 'Tive uma ótima experiência ao encomendar na Sancta Fatia. O processo de encomenda é simples e eficiente. Recebi um atendimento excelente e o sabor é incrível.',
  },
  {
    date: new Date(),
    name: 'Alice Santos',
    photoUrl: '/comments-profiles/alice.png',
    text: 'Minha encomenda na Sancta Fatia foi entregue pontualmente e o processo foi simples e claro. O sabor do bolo é sensacional, sem comentários.',
  },
  {
    date: new Date(),
    name: 'Douglas de Almeida',
    photoUrl: '/comments-profiles/douglas.png',
    text: 'Fiz a encomenda para o aniversário do meu filho e o processo foi extremamente fácil. O atendimento foi impecável, com a equipe sempre disponível para esclarecer dúvidas e ajudar na escolha dos produtos. Sem dúvida, recomendo!',
  },
]
